import styled from 'styled-components';

const StepMLStyled = styled.div`
  .step-form-wrap {
    font-family: SourceHanSansCN;
    .text-input-style {
      width: 100%;
    }
    .text-input-align-style input {
      text-align: right;
    }
    .MuiTypography-colorTextSecondary {
      color: #000000;
    }
    .MuiRadio-colorSecondary.Mui-checked {
      color: ${(props) => props.theme.palette.primary.main};
    }
    .input-error-style {
      color: #f44336;
      margin: 0;
      font-size: 0.75rem;
      margin-top: 3px;
      text-align: left;
      font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
      font-weight: 400;
      line-height: 1.66;
      /* margin-left: 14px; */
      letter-spacing: 0.03333em;
    }
    .select-wrap-style {
      width: 100%;
      justify-content: center;
    }
    .textField-area-wrap {
      height: auto;
      textarea {
        padding-top: 10px;
      }
    }
    .amount-input-style > div {
      display: flex;
      justify-content: center;
    }
    .step-input-style {
      margin-left: 0;
      input {
        border: none;
        outline-color: transparent;
        border-bottom: 1px solid rgba(0, 0, 0, 0.42);
      }
      .step-input-focus-style,
      .step-input-hover-style {
        position: relative;
      }
      .step-input-hover-style:hover::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 2px;
        bottom: 0;
        left: 0;
        background-color: ${(props) => props.theme.palette.primary.main};
        /* display: none; */
      }
      .step-input-focus-style::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 2px;
        bottom: 0;
        left: 0;
        background-color: ${(props) => props.theme.palette.primary.main};
      }
    }
    .disabled-input-style input {
      border-bottom-style: dotted;
      color: rgba(0, 0, 0, 0.38);
    }
  }
  .file_name {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    background-color: ${(props) =>
      props.queryType === 'detail' ? '#fff' : '#e0e0e0'};
    border-radius: 16px;
    padding-left: 12px;
    padding-right: 12px;
  }
`;
export default StepMLStyled;
